"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.basicFormModule = void 0;
const tslib_1 = require("tslib");
const mergeClassName_1 = tslib_1.__importDefault(require("../../utils/mergeClassName"));
const DataFormField_1 = tslib_1.__importDefault(require("../DataFormField"));
const definitions_1 = require("../definitions");
// @ts-ignore
const fillDefaultValue_1 = require("./basicForm/fillDefaultValue");
// @ts-ignore
const deleteProperty_1 = tslib_1.__importDefault(require("./basicForm/deleteProperty"));
// @ts-ignore
const addProperty_1 = tslib_1.__importDefault(require("./basicForm/addProperty"));
const settingsSchema = {
    type: "object",
    fields: [
        { id: "hideLabel", type: "boolean" },
        { id: "className", type: "string" },
        { id: "columns", type: "integer", enum: [{ value: 1 }, { value: 2 }, { value: 3 }] },
        { id: "hideAddProperty", type: "boolean", title: "不允许添加属性" },
        { id: "hideDeleteProperty", type: "boolean", title: "不允许删除属性" },
    ]
};
const component = {
    name: 'basic-form',
    mixins: [definitions_1.vueComponentMixin],
    computed: {
        stub() {
            return this.container.stub;
        },
    },
    methods: {
        commitChange(action, id, fieldValue) {
            const stub = this.stub;
            const newValue = stub.prepareValueForChange();
            if (action === 'delete')
                this.$delete(newValue, id);
            if (action === 'set')
                this.$set(newValue, id, fieldValue);
            stub.setValue(newValue);
        },
        /** 用于添加字段的（设置指定字段为默认值） */
        handleAddField(id) {
            const stub = this.stub;
            const childStub = stub.getChildStub(id);
            if (!childStub)
                return;
            this.commitChange("set", id, childStub.getDefaultValue());
            // 自动聚焦那个输入框（如果存在）
            setTimeout(() => {
                var _a;
                try {
                    const el = (_a = this.$el.current) === null || _a === void 0 ? void 0 : _a.querySelector(`.ds-dataField[data-path="${childStub.path}"]`);
                    if (!el)
                        return;
                    if (typeof el['scrollIntoViewIfNeeded'] === 'function')
                        el.scrollIntoViewIfNeeded();
                    else
                        el.scrollIntoView();
                    const input = el.querySelector('select, input, textarea');
                    input.focus();
                    input.select();
                }
                catch (_b) { }
            }, 200);
        },
    },
    render(h) {
        var _a;
        const props = this.$props;
        const { uiSettings: settings, readonly } = props;
        const stub = this.stub;
        const additionalFields = stub.additionalFields;
        const { fields, candidates } = stub.getFields();
        const fieldIds = fields.map(x => x.id);
        const commitChange = this.commitChange;
        /** 各子字段的 event handler */
        const itemHandlers = fieldIds.map(id => ({
            handleDelete: () => commitChange('delete', id, undefined),
        }));
        const handleAddField = this.handleAddField;
        // 是否去掉全部的删除按钮
        const allIndelible = readonly ||
            settings.hideDeleteProperty ||
            fields.every(x => x.required); // 全部都必填，且无不定项property，就可以全局隐藏
        const className = (0, mergeClassName_1.default)("ds-basicForm", ((_a = settings.columns) !== null && _a !== void 0 ? _a : 0) > 1 && `ds-basicForm-columns-${settings.columns}`, settings.className, props.ui.className, props.className);
        if (props.collapsed) {
            return h('div', {
                class: (0, mergeClassName_1.default)("ds-collapsedBasicForm", props.ui.className, props.className),
                on: { click: () => { this.container.setCollapsed(false); } }
            }, [
                stub.getSummary()
            ]);
        }
        return h('div', {
            class: className,
            style: props.ui.style,
        }, [
            ...fields.map((field, index) => {
                const id = field.id;
                const value = props.value[id];
                const isUndefined = value === undefined;
                const handlers = itemHandlers[index];
                if (field.hidden)
                    return null;
                return h(DataFormField_1.default, {
                    key: id,
                    props: {
                        readonly: readonly,
                        internalParentStub: stub,
                        path: id,
                        label: settings.hideLabel ? false : undefined,
                        // 在字段不存在的时候，显示一个“使用默认值填充”的按钮，作为“输入组件”
                        componentModule: isUndefined ? fillDefaultValue_1.fillDefaultValueModule : undefined,
                    }
                }, [
                    // slot
                    allIndelible ? null : h(deleteProperty_1.default, {
                        slot: 'middle',
                        props: {
                            name: field.title || field.id,
                            deletable: !field.required
                        },
                        on: { click: handlers.handleDelete }
                    })
                ]);
            }),
            (!(readonly || settings.hideAddProperty) ?
                h(addProperty_1.default, {
                    props: {
                        fields: candidates,
                        additionalFields: !!additionalFields,
                    },
                    on: {
                        addField: handleAddField
                    }
                }) :
                null)
        ]);
    }
};
exports.default = component;
exports.basicFormModule = {
    id: "basicForm",
    component,
    settingsSchema,
    collapsible: true,
};
//# sourceMappingURL=basicForm.js.map